import { GetterTree } from 'vuex'
import { SwatchesState } from './swatches.types'

export const getters: GetterTree<SwatchesState, unknown> = {
  swatches(state) {
    return state.swatches
  }
}
